<template>
  <form
    class="px-2 pt-2"
    name="formAddFilhos"
    novalidate>
    <div class="row align-items-end no-gutters">
      <div class="col-sm-3 mr-3">
        <div class="form-group">
          <label
            class="label"
            for="nome">Nome do Filho</label>
          <input
            id="nome_filho"
            v-model.lazy="filho.nome"
            v-uppercase
            class="form-control form-control-sm text-uppercase"
            name="nome"
            placeholder="Enzo Silva"
            type="text"
            @input="changed">
        </div>
      </div>

      <div class="col-sm-2 col-md-1 mr-3">
        <div class="form-group">
          <label
            class="label"
            for="idade">Idade</label>
          <input
            id="idade"
            v-model="filho.idade"
            :disabled="filho.ignorado"
            class="form-control form-control-sm"
            name="idade"
            placeholder="0"
            type="number"
            @change="changed">
        </div>
      </div>

      <div class="col-sm-2 col-md-1 mr-3">
        <div class="form-group">
          <label
            class="label"
            for="idade">Tipo idade</label>
          <select v-model="filho.idade_tipo"
                  class="form-control form-control-sm"
                  :disabled="filho.ignorado"
                  @change="changed">
            <option v-for="(tipo, index) in tipoIdade"
                    :key="`tipo_idade_${ _uid }_${ index }`"
                    :value="tipo.short">
              {{ tipo.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <span class="custom-control custom-switch custom-control-inline mr-4">
            <input
              :id="`ignorado-${filho.filho_deixado_id}`"
              v-model="filho.ignorado"
              class="custom-control-input"
              :name="`ignorado-${filho.filho_deixado_id}`"
              type="checkbox"
              @change="onIgnored"
              @keyup.enter="changeInputs('ignorado')">
            <label
              class="custom-control-label"
              :for="`ignorado-${filho.filho_deixado_id}`">Ignorada</label>
          </span>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <span class="custom-control custom-switch custom-control-inline mr-2">
            <input
              :id="`falecido-${filho.filho_deixado_id}`"
              v-model="filho.falecido"
              class="custom-control-input"
              :name="`falecido-${filho.filho_deixado_id}`"
              type="checkbox"
              @change="changed"
              @keyup.enter="changeInputs('falecido')">
            <label
              class="custom-control-label"
              :for="`falecido-${filho.filho_deixado_id}`">falecido</label>
          </span>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <span class="custom-control custom-switch custom-control-inline mr-2">
            <input
              :id="`interditado-${filho.filho_deixado_id}`"
              v-model="filho.interditado"
              class="custom-control-input"
              :name="`interditado-${filho.filho_deixado_id}`"
              type="checkbox"
              @change="changed"
              @keyup.enter="changeInputs('interditado')">
            <label
              class="custom-control-label"
              :for="`interditado-${filho.filho_deixado_id}`">Interditado</label>
          </span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  /* constant */
  import tipoIdade from "@/constants/tiposIdade"

  export default {
    name: 'FormAddFilhos',
    props: {
      propFilho: {
        type: Object,
        default: ()=>{}
      }
    },
    data () {
      return {
        tipoIdade: tipoIdade,
        ignorado: false,
        filho: {
          nome: null,
          idade: null,
          idade_tipo: null,
          interditado: null,
          ignorado: false,
          falecido: false,
        }
      }
    },
    watch: {
      propFilho () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    mounted () {
      setTimeout (() => {
        const nomeFilho = document.getElementById('nome_filho')

        if (nomeFilho) nomeFilho.focus()
      }, 50)
    },
    methods: {
      init () {
        Object.assign(this.filho, this.propFilho)

        if (this.filho.idade_tipo == "I") {
          this.filho.ignorado = true
        } else if (!!this.filho.idade_tipo) {
          this.filho.ignorado = false
        } else {
          this.filho.idade_tipo = 'A'
          this.filho.ignorado = false
        }
      },
      changed () {
        this.upperName()
        this.filho.idade = this.filho.idade || null
        this.$emit("filhoAdded", this.filho)
      },
      focusContinue () {
        const btn = document.querySelector('#btn_filhos_continue')
        
        if (btn) btn.focus()
      },
      onIgnored () {
        if (this.filho.ignorado) {
          this.filho.idade_tipo = 'I'
        } else {
          this.filho.idade_tipo = 'A'
        }
        this.changed()
      },
      changeInputs (tipo) {
        if (tipo == 'ignorado') {
          this.filho.ignorado = !this.filho.ignorado

          this.onIgnored()
        } else  if (tipo == 'interditado') {
          this.filho.interditado = !this.filho.interditado

          this.changed()
        } else {
          this.filho.falecido = !this.filho.falecido
          this.changed()
        }
      },
      upperName () {
        if (this.filho.nome) {
          this.filho.nome = this.filho.nome.toUpperCase()
        }
      }
    }

  }
</script>

<style scoped>

</style>
